import React, { createContext, useContext, useState } from 'react';
import { LeadFormModal } from './LeadFormModal';

const FormModalContext = createContext({ openForm: () => {} });

export const useFormModal = () => useContext(FormModalContext);

export const FormModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openForm = () => setOpen(true);

  return (
    <FormModalContext.Provider value={{ openForm }}>
      {children}
      <LeadFormModal open={open} onOpenChange={setOpen} />
    </FormModalContext.Provider>
  );
};
